import Image from '@/components/Image/Image';
import { Box } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';

export interface IEntityGestionnaireRowProps {
	name:     string;
	email:    string;
	photoUrl: string | null;
}

const EntityGestionnaireRow = ({ name, email, photoUrl }: IEntityGestionnaireRowProps) => (
	<Box display="flex" alignItems="center" gap="15px" py="8px">
		<Box minWidth="42px" maxWidth="42px" height="42px">
			<Image errorSize="sm" type="profile" borderRadius="full" src={photoUrl || undefined} width="42px" height="42px" objectFit="cover" />
		</Box>
		<Box display="flex" flexDirection="column" gap="2px">
			<Text lineHeight="1" className="poppins-semibold" fontSize="14px">{name}</Text>
			<Text lineHeight="1" fontSize="12px" color="gray.500">{email}</Text>
		</Box>
	</Box>
);

export default EntityGestionnaireRow;
